import defaultState from './db';

function getState(state, view, id) {
  return state.getIn(['views', view, id], defaultState);
}

const queries = { getState };

export default queries;
